import { IClassname } from '@/lib/shared/model/classname';

export const Microwave = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.3064 12.8055C24.3064 13.3139 24.5084 13.8015 24.8678 14.161C25.2273 14.5205 25.7149 14.7224 26.2233 14.7224C26.7317 14.7224 27.2192 14.5205 27.5787 14.161C27.9382 13.8015 28.1401 13.3139 28.1401 12.8055C28.1401 12.2972 27.9382 11.8096 27.5787 11.4501C27.2192 11.0906 26.7317 10.8887 26.2233 10.8887C25.7149 10.8887 25.2273 11.0906 24.8678 11.4501C24.5084 11.8096 24.3064 12.2972 24.3064 12.8055Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3064 19.1952C24.3064 19.7036 24.5084 20.1911 24.8678 20.5506C25.2273 20.9101 25.7149 21.1121 26.2233 21.1121C26.7317 21.1121 27.2192 20.9101 27.5787 20.5506C27.9382 20.1911 28.1401 19.7036 28.1401 19.1952C28.1401 18.6868 27.9382 18.1992 27.5787 17.8398C27.2192 17.4803 26.7317 17.2783 26.2233 17.2783C25.7149 17.2783 25.2273 17.4803 24.8678 17.8398C24.5084 18.1992 24.3064 18.6868 24.3064 19.1952Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.85979 3.85938H28.1402C28.1402 3.85938 30.696 3.85938 30.696 6.41521V21.7502C30.696 21.7502 30.696 24.306 28.1402 24.306H3.85979C3.85979 24.306 1.30396 24.306 1.30396 21.7502V6.41521C1.30396 6.41521 1.30396 3.85938 3.85979 3.85938Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.85986 28.1404V24.3066"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.1401 28.1404V24.3066"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.7507 3.85938V24.306"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
